import { render, staticRenderFns } from "./drawer-content-wrapper.vue?vue&type=template&id=5384defa&scoped=true&"
import script from "./drawer-content-wrapper.vue?vue&type=script&lang=ts&"
export * from "./drawer-content-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./drawer-content-wrapper.vue?vue&type=style&index=0&id=5384defa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5384defa",
  null
  
)

export default component.exports